import { Divider, Grid } from '@material-ui/core';
import { Colors, Text } from 'library';
import React from 'react';

import { StatsModel } from '../Community';

export default function ReferralStats({ referralStats }: { referralStats: StatsModel }) {
    return (
        <Grid
            style={{
                backgroundColor: Colors.lightTurq,
                marginBottom: -20,
                border: 'solid',
                borderWidth: 5,
                borderColor: Colors.white,
                padding: 25,
                borderTopLeftRadius: 18,
                borderTopRightRadius: 18,
            }}
        >
            <Grid container justify="center" direction="row">
                <Grid container item xs={5} alignItems="center" direction="column">
                    <Text variant="body1">Invites Sent</Text>
                    <Text variant="display">{referralStats.number_sent}</Text>
                </Grid>
                <Grid container item xs={1} justify="center">
                    <Divider style={{ background: Colors.darkNavy }} orientation="vertical" />
                </Grid>
                <Grid container item xs={6} sm={5} alignItems="center" direction="column">
                    <Text variant="body1">Invites Accepted</Text>
                    <Text variant="display">{referralStats.number_joined}</Text>
                </Grid>
            </Grid>
        </Grid>
    );
}
